import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Field, reduxForm } from "redux-form";
import DateTime from '_class/DateTime';
import { Collapsible, Spinner } from 'UI';
import { Plus, Minus } from 'UI/Icons';
import { Button, Radio, Flex, translate } from '@haldor/ui';
import { getMeetingTimeBlocks } from 'actions/timeblocks';
import { updateMeetingInstanceDate } from 'actions/meetings';
import './_BookMeeting.scss';
var BookMeeting = /*#__PURE__*/function (_Component) {
  function BookMeeting(props) {
    var _this;
    _classCallCheck(this, BookMeeting);
    _this = _callSuper(this, BookMeeting, [props]);
    _defineProperty(_this, "componentDidMount", function () {
      Promise.all([_this.props.getMeetingTimeBlocks(_this.props.meeting.id)]).then(function () {
        _this.setState({
          loading: false
        });
      });
    });
    _defineProperty(_this, "required", function (value, values) {
      if (value == null) {
        return translate('Select a time');
      }
      return undefined;
    });
    _defineProperty(_this, "submit", function (values) {
      var onClose = _this.props.onClose;
      _this.setState({
        loading: true
      });
      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
          var slots, slot, date, endTime, obj;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                slots = [];
                _this.props.meetingTimeBlocks.map(function (timeBlock) {
                  slots.push.apply(slots, _toConsumableArray(timeBlock.timeBlockSlots));
                });
                slot = slots.find(function (item) {
                  return item.id == values.timeBlockSlotId;
                });
                if (!(slot != null)) {
                  _context.next = 10;
                  break;
                }
                date = moment.utc(slot.startTime);
                endTime = moment.utc(slot.endTime);
                obj = {
                  id: _this.props.instance.id,
                  meetingId: _this.props.meeting.id,
                  timeBlockSlotId: slot.id,
                  date: date.format('YYYY-MM-DDTHH:mm:ss'),
                  endDate: endTime.format('YYYY-MM-DDTHH:mm:ss')
                };
                _this.props.updateMeetingInstanceDate(obj, _this.props.instance.id).then(function () {
                  if (_this.props.instance.date != null) {
                    onClose(null, true);
                  } else {
                    Promise.all([_this.props.getMeetingTimeBlocks(_this.props.meeting.id)]).then(function () {
                      _this.setState({
                        loading: false,
                        error: true
                      });
                    });
                    resolve(0);
                  }
                });
                _context.next = 15;
                break;
              case 10:
                _context.next = 12;
                return _this.props.getMeetingTimeBlocks(_this.props.meeting.id);
              case 12:
                _this.setState({
                  loading: false,
                  error: true
                });
                resolve(1);
                return _context.abrupt("return");
              case 15:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    });
    _defineProperty(_this, "onCancel", function (event) {
      // Prevent button submitting form
      event.preventDefault();
      _this.props.onClose(null, false);
    });
    _this.state = {
      dates: null,
      loading: true,
      error: false
    };
    return _this;
  }
  _inherits(BookMeeting, _Component);
  return _createClass(BookMeeting, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }
      var _this$props = this.props,
        handleSubmit = _this$props.handleSubmit,
        valid = _this$props.valid,
        translate = _this$props.translate;
      if (this.props.meetingTimeBlocks.length == 0) {
        return /*#__PURE__*/React.createElement("div", {
          className: "form-container"
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            marginBottom: '2rem'
          },
          className: "text--center color--meta"
        }, translate('There are currently no bookable times')));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, this.state.error != null && this.state.error == true ? /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginBottom: '1.8em',
          color: 'red',
          fontWeight: '500'
        }
      }, this.props.translate("The time you selected is no longer available. Please choose a different time.")) : null, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement("div", null, this.props.meetingTimeBlocks.map(function (timeblock) {
        var trigger = function trigger(open) {
          return /*#__PURE__*/React.createElement("div", {
            className: ""
          }, /*#__PURE__*/React.createElement("div", {
            className: "",
            style: {
              display: 'flex'
            }
          }, /*#__PURE__*/React.createElement("div", {
            style: {
              flex: '1'
            }
          }, new DateTime(timeblock.startTime).getDateString().capitalize()), /*#__PURE__*/React.createElement(Flex, {
            center: true
          }, new DateTime(timeblock.startTime).getTime(), ' - ', new DateTime(timeblock.endTime).getTime(), /*#__PURE__*/React.createElement("div", {
            className: "open-indicator"
          }, open ? /*#__PURE__*/React.createElement(Minus, null) : /*#__PURE__*/React.createElement(Plus, null)))));
        };
        var slots = timeblock.timeBlockSlots.filter(function (t) {
          return moment(t.startTime) < moment(timeblock.endTime) && moment(t.endTime) > moment(timeblock.startTime);
        });
        return /*#__PURE__*/React.createElement("div", {
          className: "meeting--slots",
          key: timeblock.id
        }, /*#__PURE__*/React.createElement(Collapsible, {
          trigger: trigger
        }, /*#__PURE__*/React.createElement("div", {
          className: "slots-container"
        }, slots.map(function (slot, i) {
          var label = moment.utc(slot.startTime).local().format('HH:mm') + ' - ' + moment.utc(slot.endTime).local().format('HH:mm');
          var available = slot.available && moment.utc(slot.startTime) > moment.utc();
          var bookable = slot.bookable;
          return /*#__PURE__*/React.createElement("div", {
            className: "slot",
            key: 'slot-' + i
          }, /*#__PURE__*/React.createElement(Field, {
            component: Radio,
            optionValue: slot.id,
            disabled: !available || !bookable,
            name: "timeBlockSlotId",
            label: label,
            validate: _this2.required
          }));
        }))));
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: !valid
      }, translate('Save')), /*#__PURE__*/React.createElement("div", {
        className: "pull-right"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.onCancel
      }, translate('Cancel'))))));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    meetingTimeBlockSlots: state.TimeBlocks.meetingTimeBlockSlots,
    meetingTimeBlocks: state.TimeBlocks.meetingTimeBlocks,
    activeStudent: state.User.activeStudent,
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps, {
  getMeetingTimeBlocks: getMeetingTimeBlocks,
  updateMeetingInstanceDate: updateMeetingInstanceDate
})(reduxForm({
  form: 'BookMeetingBlocks',
  destroyOnUnmount: true
})(BookMeeting));